import React, { useEffect, useState } from "react";

function SubcategoryModal({
  mode,
  subcategory,
  isNameTaken,
  onSave,
  onClose,
  saving,
}) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [visible, setVisible] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setName(subcategory?.subCategoryName || "");
    setDescription(subcategory?.description || "");
    setVisible(subcategory?.visible ?? true);
    setError("");
  }, [subcategory]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const trimmedName = name.trim();
    const trimmedDescription = description.trim();
    if (!trimmedName) {
      setError("Name is required.");
      return;
    }
    if (!trimmedDescription) {
      setError("Description is required.");
      return;
    }

    if (isNameTaken(trimmedName, subcategory?.subCategoryId || "")) {
      setError("Subcategory names must be unique within the selected category.");
      return;
    }

    onSave({ name: trimmedName, description: trimmedDescription, visible });
  };

  return (
    <div className="cs-modal-overlay" onClick={saving ? undefined : onClose}>
      <form
        className="category-settings-modal"
        onClick={(e) => e.stopPropagation()}
        onSubmit={handleSubmit}
      >
        <div className="category-settings-modal-title">
          {mode === "edit" ? "Edit Subcategory" : "Add Subcategory"}
        </div>

        <label className="category-settings-field">
          <span>Subcategory Name</span>
          <input
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              if (error) setError("");
            }}
            placeholder="Type subcategory name"
            autoFocus
          />
        </label>

        <label className="category-settings-field">
          <span>Description</span>
          <textarea
            value={description}
            onChange={(e) => {
              setDescription(e.target.value);
              if (error) setError("");
            }}
            placeholder="Type subcategory description"
          />
        </label>

        <label className="category-settings-modal-checkbox">
          <input
            type="checkbox"
            checked={visible}
            onChange={(e) => setVisible(e.target.checked)}
          />
          <span>Display to Users</span>
        </label>

        {error ? <div className="category-settings-error">{error}</div> : null}

        <div className="category-settings-modal-actions">
          <button className="cs-btn cs-btn-blue" type="submit" disabled={saving}>
            {saving ? "Saving..." : "Save"}
          </button>
          <button
            className="cs-btn cs-btn-outline"
            type="button"
            onClick={onClose}
            disabled={saving}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default SubcategoryModal;
